<template>
  <admin-layout :title="$t('Activity')">
    <div class="px-4 md:px-0">
      <tec-section-title class="mb-6">
        <template #title> {{ $t('Activities') }} </template>
        <template #description> {{ $t('Please review the data in the table below') }} </template>
      </tec-section-title>

      <div class="mb-6 flex justify-between items-center">
        <search-filter :dropdown="false" v-model="form.search" class="w-full max-w-md mr-4" @reset="reset" />
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">{{ $t('Created at') }}</th>
            <th class="px-6 pt-6 pb-4">{{ $t('Name') }}</th>
            <th class="px-6 pt-6 pb-4">{{ $t('Description') }}</th>
            <th class="px-6 pt-6 pb-4">{{ $t('By') }}</th>
          </tr>
          <tr v-for="activity in activities.data" :key="activity.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t px-6 py-4">
              {{ $datetime(activity.created_at) }}
            </td>
            <td class="border-t px-6 py-4">
              {{ activity.log_name }}
            </td>
            <td class="border-t px-6 py-4">
              {{ activity.description }}
            </td>
            <td class="border-t px-6 py-4">
              {{ activity.causer ? activity.causer.name : '' }}
            </td>
          </tr>
          <tr v-if="activities.length === 0">
            <td class="border-t px-6 py-4" colspan="4">{{ $t('There is no data to display.') }}</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :meta="activities.meta" :links="activities.links" />
    </div>
  </admin-layout>
</template>

<script>
import pickBy from 'lodash/pickBy';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import TecButton from '@/Jetstream/Button';
import SelectInput from '@/Shared/SelectInput';
import Pagination from '@/Shared/Pagination';
import AdminLayout from '@/Layouts/AdminLayout';
import SearchFilter from '@/Shared/SearchFilter';
import TecSectionTitle from '@/Jetstream/SectionTitle';

export default {
  components: {
    TecButton,
    Pagination,
    AdminLayout,
    SelectInput,
    SearchFilter,
    TecSectionTitle,
  },

  props: {
    filters: Object,
    activities: Object,
  },

  data() {
    return {
      form: { search: this.filters.search },
    };
  },

  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form);
        this.$inertia.get(
          this.route('activity', Object.keys(query).length ? query : { remember: 'forget' }),
          {},
          { replace: true, preserveState: true }
        );
      }, 150),
      deep: true,
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },
  },
};
</script>
